import * as React from 'react';
import classNames from 'classnames';
import DefaultPanel from "./DefaultPanel";

var TourStep = function TourStep(props) {
  var className = props.className,
      prefixCls = props.prefixCls,
      current = props.current,
      renderPanel = props.renderPanel;
  var mergedClassName = classNames("".concat(prefixCls, "-inner"), className);
  return /*#__PURE__*/React.createElement("div", {
    className: mergedClassName
  }, typeof renderPanel === 'function' ? renderPanel(props, current) : /*#__PURE__*/React.createElement(DefaultPanel, props));
};

export default TourStep;